import CtaBanner from "@/components/site/CtaBanner";
import { Leaf, Handshake, ReceiptText, Building2, Factory } from "lucide-react";

const VALUES = [
  { icon: Leaf, t: "Simple energy", b: "Clear, usage-based billing without complicated system ownership burdens." },
  { icon: Factory, t: "Cleaner business", b: "On-site solar and battery designed for real commercial operations." },
  { icon: Handshake, t: "Long-term partnerships", b: "We stay involved for the full term of the agreement — not just installation." },
  { icon: ReceiptText, t: "Transparent billing", b: "One agreed cents-per-kWh rate for on-site energy. No hidden layers." },
  { icon: Building2, t: "Practical commercial outcomes", b: "Focused on outcomes CFOs and operators actually care about." },
];

export default function About() {
  return (
    <div>
      <section className="container-x mx-auto max-w-7xl pt-14 md:pt-24 pb-16 grid lg:grid-cols-[1.1fr_1fr] gap-14 items-center" data-testid="about-hero">
        <div>
          <p className="text-forest text-xs tracking-[0.18em] uppercase font-semibold mb-4">About Be Green Group</p>
          <h1 className="font-heading text-4xl md:text-6xl font-semibold text-forest leading-[1.03] tracking-tight">
            Cleaner business energy, without the upfront cost.
          </h1>
          <p className="mt-6 text-neutral-600 text-lg leading-relaxed max-w-xl">
            Be Green Group helps Australian businesses access cleaner on-site energy without the
            upfront cost of purchasing solar and battery systems. Our team works with commercial
            customers, energy specialists, project partners and funding partners to deliver
            simple, usage-based renewable energy solutions.
          </p>
          <p className="mt-4 text-neutral-600 text-[15.5px] leading-relaxed max-w-xl">
            We’re a commercial energy company, not a residential installer. Everything we design is
            built around commercial load profiles, operating patterns and long-term site occupancy.
          </p>
        </div>
        <div className="relative">
          <img
            src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxDRk8lMjBidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzgzNTc3ODU2fDA&ixlib=rb-4.1.0&q=85"
            alt="Commercial business meeting"
            className="w-full h-[380px] md:h-[460px] object-cover rounded-3xl shadow-xl"
          />
        </div>
      </section>

      <section className="bg-mist py-16 md:py-24" data-testid="about-values">
        <div className="container-x mx-auto max-w-7xl">
          <div className="flex items-end justify-between gap-6 mb-10 flex-wrap">
            <div>
              <p className="text-forest text-xs tracking-[0.18em] uppercase font-semibold mb-3">What we value</p>
              <h2 className="font-heading text-3xl md:text-5xl font-semibold text-forest leading-[1.05] max-w-2xl">Straightforward energy for real commercial businesses.</h2>
            </div>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4">
            {VALUES.map((v) => (
              <div key={v.t} className="rounded-2xl bg-white p-6 border border-black/5">
                <span className="grid place-items-center h-10 w-10 rounded-xl bg-mist text-forest">
                  <v.icon size={18} strokeWidth={2.2} />
                </span>
                <h4 className="mt-4 font-heading font-semibold text-forest text-[16px]">{v.t}</h4>
                <p className="mt-2 text-[14px] text-neutral-600 leading-relaxed">{v.b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBanner testId="about-cta" />
    </div>
  );
}
